import { render, staticRenderFns } from "./SendLowBalanceNotice.vue?vue&type=template&id=52b1da6a&scoped=true"
import script from "./SendLowBalanceNotice.vue?vue&type=script&lang=js"
export * from "./SendLowBalanceNotice.vue?vue&type=script&lang=js"
import style0 from "./SendLowBalanceNotice.vue?vue&type=style&index=0&id=52b1da6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b1da6a",
  null
  
)

export default component.exports